import axios from "axios";

// const API_BASE_URL = "https://vuongsoftwaredevelopment-backend.vercel.app";
const API_BASE_URL = "https://baccarat-backend.vercel.app";
// const API_BASE_URL = "http://localhost:4000";

// Example: Get Hello Message
export const echoData = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/search-shoes`);
    return response.data;
  } catch (error) {
    console.error("Error fetching hello message:", error);
    throw error;
  }
};

// Example: Echo Data
export const getSearchShoes = async (patterns, page, pageSize) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/search-shoes`, { patterns, page, pageSize });
    return response.data;
  } catch (error) {
    console.error("Error posting echo data:", error);
    throw error;
  }
};


// // Example: Echo Data
// export const getSearchOneShoe = async (shoeNo) => {
//   try {
//     const response = await axios.post(`${API_BASE_URL}/search-one-shoe`, { shoeNo });
//     return response.data;
//   } catch (error) {
//     console.error("Error posting echo data:", error);
//     throw error;
//   }
// };


// Example: Echo Data
export const getSearchOneShoe = async (shoeNo) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/search-one-shoe?shoe_no=${shoeNo}`);
    return response.data;
  } catch (error) {
    console.error("Error posting echo data:", error);
    throw error;
  }
};




// Example: Echo Data
export const getRandomShoes = async (inputData = "") => {
  try {
    // Use the inputData as a query parameter if it's provided
    const response = await axios.get(`${API_BASE_URL}/random-shoes`, {
      params: {
        shoe_no: inputData, // Send the inputData as a query parameter
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching random shoes:", error);
    throw error;
  }
};